import { call, put, takeLatest } from 'redux-saga/effects';
import { dealerNurturingAutomationSettingsActions } from './slice';
import {
  fetchDealerNurturingAutomationSettings,
  updateDealerNurturingAutomationSettings,
} from './data/dealerNurturingAutomationSettingsDataService';
import { notificationAlertActions } from 'app/pages/NotificationAlert/slice';

function* fetchDealerNurturingAutomationSettingsSaga(action: ReturnType<any>) {
  try {
    const response = yield call(fetchDealerNurturingAutomationSettings, {
      dealershipId: action.payload.dealershipId,
    });
    yield put(
      dealerNurturingAutomationSettingsActions.requestDealerNurturingAutomationSettingsSuccess(
        response,
      ),
    );
  } catch (error: any) {
    yield put(
      dealerNurturingAutomationSettingsActions.requestDealerNurturingAutomationSettingsError(
        error.message,
      ),
    );
    yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message: 'Dealer nurturing automation settings fetch failed',
      }),
    );
  }
}

function* updateDealerNurturingAutomationSettingsSaga(
  action: ReturnType<any>,
) {
  const dealershipId = action.payload.dealershipId;
  try {
    yield call(updateDealerNurturingAutomationSettings, {
      dealershipId,
      data: action.payload.data,
      settingsId: action.payload.settingsId,
    });
    yield put(
      dealerNurturingAutomationSettingsActions.requestUpdateDealerNurturingAutomationSettingsSuccess(),
    );
    yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'success',
        message: 'Dealer nurturing automation settings saved',
      }),
    );
    yield put(
      dealerNurturingAutomationSettingsActions.requestDealerNurturingAutomationSettings(
        { dealershipId },
      ),
    );
  } catch (error: any) {
    yield put(
      dealerNurturingAutomationSettingsActions.requestUpdateDealerNurturingAutomationSettingsError(
        error.message,
      ),
    );
    yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message: 'Dealer nurturing automation settings save failed',
      }),
    );
    yield put(
      dealerNurturingAutomationSettingsActions.requestDealerNurturingAutomationSettings(
        { dealershipId },
      ),
    );
  }
}

export function* watchDealerNurturingAutomationSettingsSaga() {
  yield takeLatest(
    dealerNurturingAutomationSettingsActions
      .requestDealerNurturingAutomationSettings.type,
    fetchDealerNurturingAutomationSettingsSaga,
  );
  yield takeLatest(
    dealerNurturingAutomationSettingsActions
      .requestUpdateDealerNurturingAutomationSettings.type,
    updateDealerNurturingAutomationSettingsSaga,
  );
}
